module.exports = __webpack_public_path__ + "static/media/event-services-img6.958c3cfc.jpg";